import React, { useMemo } from 'react'
import TournamentItem from '../../../../components/list-items/components/tournamentItem'
import PaginatedList from '../../../../components/PaginatedList'
import { useEventTournaments } from './hooks/useEventTournaments'
import styles from './styles.module.scss'

const EventFooter = ({ eventId }) => {
  const { tournaments, pagination, requestSuccess, handlePageChange } =
    useEventTournaments(eventId)

  const renderTournament = useMemo(
    () => tournament => <TournamentItem {...tournament} />,
    []
  )

  return (
    <PaginatedList
      items={tournaments}
      pagination={pagination}
      isLoading={!requestSuccess}
      renderItem={renderTournament}
      itemKey='uuid'
      onPageChange={handlePageChange}
      titleId='calendar.tournaments'
      className={styles.events__tournaments}
      listClassName={styles.event__list__events}
      emptyMessageId='community.tournaments.noMore'
    />
  )
}

export default EventFooter
